import type {DataLayout, GridSection, PlaceholderBlock} from 'analysis-tool/data-layout/DataLayoutTypes';

export const DEFAULT_LAYOUT_ROWS = 2;
export const DEFAULT_LAYOUT_COLUMNS = 2;

const PLACEHOLDER_BLOCK: PlaceholderBlock = {type: 'PLACEHOLDER'};

type DefaultGridSection = Omit<GridSection, 'rows'> & {rows: Array<Array<PlaceholderBlock>>};

export interface DefaultLayoutConfig {
  name: DataLayout['name'];
  sections: Array<DefaultGridSection>;
}

export const DEFAULT_LAYOUT_CONFIG: DefaultLayoutConfig = {
  name: '[New Layout]',
  sections: [
    {
      type: 'GRID',
      title: null,
      gridMode: 'SEPARATED',
      rows: Array(DEFAULT_LAYOUT_ROWS)
        .fill(null)
        .map(() =>
          Array(DEFAULT_LAYOUT_COLUMNS)
            .fill(null)
            .map(() => PLACEHOLDER_BLOCK)
        ),
    },
  ],
};
